import React, { createContext, useState } from 'react';
import { useSelector } from 'react-redux';

export const MinorUserContext = createContext(null);

// TODO: update so this depends on birthday, not set at bday screen
const MinorUserProvider = ({ children }) => {
  const [isMinor, setIsMinor] = useState(false);

  const user = useSelector((state) => state.user);

  const userFirstName = user.firstName;

  return <MinorUserContext.Provider value={{ firstName: userFirstName, isMinor, setIsMinor }}>{children}</MinorUserContext.Provider>;
};

export default MinorUserProvider;
